import * as React from "react"
import { List } from "immutable"
import { Block, BlockRenderer } from "../components/block_renderer"
import { Jumbo } from "../components/jumbo"
import { BasePageProps } from "../components/page_renderer"
import { LocalizationProps } from "../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout"

export interface HomePageProps extends BasePageProps {
  readonly kind: "home"
  readonly pageTitle: string
  readonly headerTitle: string
  readonly description: string
  readonly headerButtonUrl: string
  readonly headerButtonTitle: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly phImageUrlSmall?: string
  readonly phImageUrl: string
  readonly phImageUrlLarge: string
  readonly imageAlt: string
  readonly universalBlocks: List<Block>
  readonly blocks: List<Block>
  readonly showAnnouncement?: boolean
  readonly announcement?: string
  readonly localizationProps?: LocalizationProps
}

export class HomePage extends React.Component<HomePageProps, {}> {
  constructor(props: HomePageProps) {
    super(props)
  }

  componentDidMount() {
    document.title = this.props.pageTitle
  }

  render() {
    const p = this.props

    return (
      <>
        <div className="home">
          <Jumbo
            title={p.headerTitle}
            contents={p.description}
            imageUrlSmall={p.phImageUrlSmall}
            imageUrl={p.phImageUrl}
            imageUrlLarge={p.phImageUrlLarge}
            imageAlt={p.imageAlt}
            buttonTitle={p.headerButtonTitle}
            buttonUrl={p.headerButtonUrl}
            size="large"
            kind="home"
            localizationProps={p.localizationProps}
          />

          <BlockRenderer blocks={p.universalBlocks} />
          <BlockRenderer blocks={p.blocks} />
        </div>
      </>
    )
  }
}

{/* TH: Added to styleguide! */}
